import { get } from '../../../common/data/common-data-service';
import { IBlocksOverviewResponse } from '../blocks-overview-interfaces';

export const getBlocksOverviewData = async (from: number, to: number) : Promise<IBlocksOverviewResponse> => {
    return await get(`/api/plan/blocks/get?from=${ from }&to=${ to }`);
};